import React, { useState } from "react";
import "./AddProviderTrackingSession.css";

import { toast } from "react-toastify";

import {
  addProviderTrackingSession,
} from "../../config/LiveApi";

const AddSessionModal = ({
  selectedId,
  onClose,
  onSuccess,
}) => {
  const [loading, setLoading] =
    useState(false);

  const [formData, setFormData] =
    useState({
      startDate: "",
      endDate: "",
      remark: "",
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await addProviderTrackingSession(
        selectedId,
        formData,
      );

      toast.success(
        "New session added successfully",
      );

      onSuccess();
      onClose();
    } catch (error) {
      toast.error(
        "Failed to add session",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="provider-tracking-modal-overlay">
      <div className="provider-tracking-modal">
        <div className="provider-tracking-modal-header">
          <h2>Add New Session</h2>

          <button
            onClick={onClose}
            className="provider-tracking-close-btn"
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="provider-tracking-form-group">
            <label>
              Start Date
            </label>

            <input
              type="date"
              required
              value={
                formData.startDate
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  startDate:
                    e.target.value,
                })
              }
            />
          </div>

          <div className="provider-tracking-form-group">
            <label>
              End Date
            </label>

            <input
              type="date"
              value={
                formData.endDate
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  endDate:
                    e.target.value,
                })
              }
            />
          </div>

          <div className="provider-tracking-form-group">
            <label>
              Remark
            </label>

            <textarea
              rows={4}
              placeholder="Enter remark..."
              value={
                formData.remark
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  remark:
                    e.target.value,
                })
              }
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="provider-tracking-submit-btn"
          >
            {loading
              ? "Please wait..."
              : "Add Session"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddSessionModal;